import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useLinksQuery, InstitutionDTO } from '../../api/useLinksQuery';
import { currentClientIdSelector } from '../../../../CommonSelectors/CommonAreaSelector';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';

export interface Institution extends InstitutionDTO {
  isLinkToMigrate?: boolean;
}

export const useManageLinks = (): AsyncComponentHookResult<Institution[]> => {
  const clientId = useSelector(currentClientIdSelector);

  const queryResult = useLinksQuery({ clientId });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    return queryResult.data.Institutions;
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
